import { render } from "./MobilePlanetsTable.vue?vue&type=template&id=44a51f4c&scoped=true"
import script from "./MobilePlanetsTable.vue?vue&type=script&lang=js"
export * from "./MobilePlanetsTable.vue?vue&type=script&lang=js"

import "./MobilePlanetsTable.vue?vue&type=style&index=0&id=44a51f4c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a51f4c"]])

export default __exports__